import React from 'react';
import {
  Folder,
  TemplateSummary,
  TemplatingItemSummary,
  CompositeReportDefinitionSummary,
} from '../../models';
import { FolderNode } from './FolderNode';
import { DraggableTemplatingItemNode } from './TemplatingItemNode';

interface FileSystemNodeProps {
  item: TemplatingItemSummary | Folder;
  folderNodeActions?: (data: Folder) => React.ReactNode;
  templateNodeActions?: (data: TemplateSummary) => React.ReactNode;
  compositeReportDefinitionNodeActions?: (
    data: CompositeReportDefinitionSummary,
  ) => React.ReactNode;
}

const FileSystemNode: React.FC<FileSystemNodeProps> = ({
  item,
  folderNodeActions,
  templateNodeActions,
  compositeReportDefinitionNodeActions,
}) => {
  if (item.type === 'folder') {
    return (
      <FolderNode
        folder={item}
        folderNodeActions={folderNodeActions}
        templateNodeActions={templateNodeActions}
      />
    );
  } else {
    return (
      <DraggableTemplatingItemNode
        templatingItem={item}
        templateNodeActions={templateNodeActions}
        compositeReportDefinitionNodeActions={
          compositeReportDefinitionNodeActions
        }
      />
    );
  }
};

export { FileSystemNode };
